import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { HttpClient } from "@angular/common/http";
import { AppConstant } from "src/app/app.constant";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DataResult, DataSourceRequestState } from "@progress/kendo-data-query";

@Injectable()
export class ActivityEventsService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    manageActivity(AcitivityEvent) {
        return this.httpClient.post(`${this.apiUrl}/manageActivity`, AcitivityEvent).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getActivityById(InstituteId) {
        return this.httpClient.get(`${this.apiUrl}/getActivityById/` + InstituteId).pipe(
            map((response: any) => {
                return response;
            })
        )
    }


    public getAllActivity(state): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllActivity/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    getAllActivityForExcelExport(state: DataSourceRequestState) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/getAllInstitute/` + state).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
}
